import { usePathname } from "next/navigation";

export type DemoLinkParameters = {
  destinationName?: string;
  sourceName?: string;
};

export const useDemoLinkWithParameters = (parameters?: DemoLinkParameters): string => {
  const pathname = usePathname();

  // Destination landing referring pages
  if (parameters?.destinationName) {
    return `/demo?destination=${encodeURI(parameters.destinationName)}`;
  }

  // Source landing referring pages
  if (parameters?.sourceName) {
    return `/demo?source=${encodeURI(parameters.sourceName)}`;
  }

  return `/demo?ref=${pathname ?? ""}`;
};
